/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { useOrgId } from '../provider';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { REVOKE_ADMIN } from '../../api/graphql';
import moment from 'moment-timezone';

import { vappContainer } from '@/application';
import { notificationConfig } from '../../config/notifications.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};

export interface RevokeAdminProps {
  vuid?: string;
}
export interface IRevokeAdminMethods extends IPluginMethodMap {
  revokeAdmin(args: RevokeAdminProps): Promise<any>;
}
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export class RevokeAdminService implements IAgentPlugin {
  readonly methods: IRevokeAdminMethods;

  constructor() {
    this.methods = {
      revokeAdmin: this.revokeAdmin.bind(this),
    };
  }

  async revokeAdmin(args: RevokeAdminProps) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    console.log(`args in invite user service`, args);
    try {
      if (client) {
        const res = await client
          .mutation(
            REVOKE_ADMIN,

            {
              ...args,
            }
          )
          .toPromise();

        if (res?.data?.revokeRole) {
          console.log(`table data`, res);
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
